import { render, staticRenderFns } from "./recallModal.vue?vue&type=template&id=0c80f4ca&scoped=true"
import script from "./recallModal.vue?vue&type=script&lang=js"
export * from "./recallModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80f4ca",
  null
  
)

export default component.exports